import Vue from 'vue'
import BFormGroup from 'b-form-group'
import Vuemerang from 'vuemerang'
import 'vuemerang/dist/vuemerang.css'

Vue.use(BFormGroup)
Vue.use(Vuemerang, {
  theme: {
    colors: {
      primary: '#0D4351',
      success: 'rgb(23, 201, 100)',
      danger: 'rgb(242, 19, 93)',
      warning: 'rgb(255, 130, 0)',
      wdas: 'rgb(226, 177, 0)',
      dark: '#ccc',
      gray: '#afbbc6'
    }
  }
})
